<template>
    <b-button variant="primary"
              :disabled="isBusy"
              @click="handleEnrol"
              class="btn-slimpad btn-block btn-white"
              :class="{ 'btn-ghost': ghost }"><slot>Take Course</slot></b-button>
</template>

<script>
    import { globalEventFire } from '../tracker.js';

    export default {
        props: {
            vodCourse: {
                type: Object,
                required: true,
            },
            user: {
                type: Object,
                required: true,
            },
            slug: {
                type: String,
                required: true,
            },
            isNewlyRegistered: {
                type: Boolean,
                required: false,
            },
            purchaseIntent: { // Not used, but tells us whether it's a subscription or free intent
                type: String,
                required: false,
            },
            ghost: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        data() {
            return {
                isBusy: false,
                hasError: false,
                error: '',
                currentUrl: '',
                isFree: false,
                isAuth: false,
                isSubscribed: false,
                isSchoolUser: false,
            }
        },

        mounted() {
            this.currentUrl = window.location.pathname;
            this.isFree = this.vodCourse.is_free; // We check server side so it's safe to do whatever here

            if(window.virtuoso) {
                if(window.virtuoso.is_auth) {
                    this.isAuth = true;
                    this.user = window.virtuoso.user;
                    this.isSchoolUser = this.user.isSchoolUser;
                }
                this.isSubscribed = window.virtuoso.is_subscribed;
            }
        },

        methods: {
            // Handle enrolment
            handleEnrol() {
                this.hasError = false;
                this.error = '';

                this.isBusy = true;

                if(this.isFree || this.isSubscribed) {
                    this.fireEnrolment();
                }
            },

            // Actually enrol them
            fireEnrolment() {
                // Fire it
                let queryStringAppend = this.isNewUser ? '?newUser=true&enrolled=true' : '?enrolled=true';
                axios.post('/api/vod_course/' + this.vodCourse.id + '/enrol')
                    .then((response) => {
                        if(response.data.success) {
                            // Fire analytics event
                            this.fireAnalytics(response.data.enrolment_id ?? 0);
                            location.href = '/my-courses/classroom/' + this.slug + '/' + this.vodCourse.id + '/' + queryStringAppend;
                        }

                        if(response.data.error) {
                            this.hasError = true;
                            this.error = response.data.error;
                            this.isBusy = false;
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.hasError = true;
                        this.error = 'An unexpected error occured.';
                        this.isBusy = false;
                    });
            },

            // Fire analytics
            fireAnalytics(enrolment_id) {
                globalEventFire('VODEnrolment', 'VOD', {
                    'name': this.vodCourse.name,
                    'analytics_tag': this.vodCourse.analytics_tag,
                    'user_id': this.user.id,
                    'email': this.user.email
                });
            },
        }
    }
</script>
